import AudioPlayer from '../../AudioPlayer/AudioPlayer';
import { FaSpinner } from 'react-icons/fa';
import useLocalization from '../../../../hooks/useLocalization';
import PropTypes from "prop-types";



const AudioResponsePlayer = ({ contentAudio, isLoading, isAutoPlay, showText,setShowText }) => {
    const { t } = useLocalization();
    return (
        <div className="mt-2">
            {isLoading ? (
                <div className="flex items-center justify-center gap-3 text-sm text-gray-600 dark:text-gray-300 animate-pulse">
                    <FaSpinner className="animate-spin text-blue-500 text-xl" />
                    <span>{t('audioGenerating') || 'Your audio is being generated...'}</span>
                </div>
            ) : (
                <AudioPlayer contentAudio={contentAudio} isAutoPlay={isAutoPlay} showText={showText} 
        setShowText={setShowText} />
            )}
        </div>
    );
};
AudioResponsePlayer.propTypes = {
    contentAudio: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    // getAudioDurationFromBase64: PropTypes.func, // unused but declared
    isAutoPlay: PropTypes.bool,
    showText: PropTypes.bool.isRequired,
    setShowText: PropTypes.func.isRequired,
};
export default AudioResponsePlayer;
